<!--
 * @Author: your name
 * @Date: 2020-05-29 14:14:12
 * @LastEditTime: 2021-03-22 17:11:56
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \heshan_web\src\components\power\addTable.vue
--> 
<template>
    <div class="addTable">
      <div class="dialogDiv">
        <el-table :data="tableData" border ref="table"  tooltip-effect="dark" style="width: 100%"
        @selection-change='selectRow'>
          
          <el-table-column prop="name" label="名称">
            <template slot-scope="scope">
              <div v-if='!scope.row.flag'>
                {{scope.row.name}}
              </div>
              <div v-if='scope.row.flag'>
                <el-input v-model="scope.row.name" ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="型号">
            <template slot-scope="scope">
              <div v-if='!scope.row.flag'>
                {{scope.row.model}}
              </div>
              <div v-if='scope.row.flag'>
                <el-input v-model="scope.row.model" ></el-input>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="数量">
            <template slot-scope="scope">
              <div v-if='!scope.row.flag'>
                {{scope.row.num}}
              </div>
              <div v-if='scope.row.flag'>
                <el-input v-model="scope.row.num" ></el-input>
              </div>
            </template>
          </el-table-column> 
        </el-table>
      </div>
    </div>
</template>

<script>

    export default {
        props: ['tableData'],
        data() {
            return {
              tagsList: [],
              childSelect:''
            }
        },
        methods: {
          selectRow () {
            console.log('xxx')
          }
        },
        watch:{

        },
        mounted () {
        }
    }

</script>


<style lang='scss'>
  .addTable{
    .has-gutter th{
      background: none!important;
      color: #8c8c8c;
    }
    .el-table--small{
      font-size: 14px;;
    }
  }
</style>
